import React from 'react'
import BlogArticleView from '../article/BlogArticleView'
import styles from './BlogEditor.module.scss'

function BlogArticlePreviewPane({ title, blocks, selectedBlockId, onSelectBlock }) {
  return (
    <aside className={styles.articlePreviewPane}>
      <p className={styles.articlePreviewTitle}>Прев’ю статті</p>
      <div className={styles.articlePreviewBody}>
        <BlogArticleView
          title={title}
          blocks={blocks}
          selectedBlockId={selectedBlockId}
          onSelectBlock={onSelectBlock}
          selectable
        />
      </div>
    </aside>
  )
}

export default BlogArticlePreviewPane
